import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useRealtimeDrivers } from 'Core/hooks';
import { useIntl } from 'react-intl';

//Components
import { NotificationContainer } from "Components/Notifications";
import { Modal, Button } from '@gpstrackit/gtc-react-controls';
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    maintenanceDDSTDeleteDriverScheduledTask,
    reset,
} from './redux/slice';

const DeleteDriverScheduledTask = (props) => {
    const { refresh } = props
    const { messages, } = useIntl();
    const dispatch = useDispatch();

    let path = location.pathname.split("/");
    const id = path[path.length - 1];

    //Redux States
    const { open, loading, tasks, response, error, driverName } = useSelector(state => state.maintenanceDeleteDriverScheduledTaskRedux);
    const drivers = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });

    //Local States
    const [driver, setDriver] = useState(null);

    useEffect(() => {
        if (open && id) {
            let currentDriver = drivers.find((e) => e?.driverId == id)
            currentDriver && setDriver(currentDriver);
        }
    }, [open])

    useEffect(() => {
        if (response) {
            NotificationManager.success(
                messages['deleteDriverScheduledTasks_success_message'],
                messages['success'],
                3000,
                null,
                null,
                'success',
            );
            refresh && refresh();
            dispatch(reset({ response: null }));
            handleClose();
        }
        if (error) {
            NotificationManager.error(
                error?.error || messages['errorMessage'],
                messages['error'],
                3000,
                null,
                null,
                'error',
            );
            dispatch(reset({ error: null }));
        }
    }, [response, error])

    const handleClose = () => {
        dispatch(reset());
        setDriver(null);
    }

    return (
        <Modal
            title={`${messages['delete']} ${`"${tasks?.driverTaskName}"` || ''}`}
            open={open}
            handleClose={handleClose}
            position="right"
            size="small"
            loading={loading}
            footer={(
                <div>
                    <Button
                        onClick={handleClose}
                        variant="secondary"
                        style={{ marginRight: "5px" }}
                    >
                        {messages['cancel']}
                    </Button>
                    <Button
                        onClick={() => dispatch(maintenanceDDSTDeleteDriverScheduledTask({ id: tasks?.id }))}
                        variant="warning"
                    >
                        {messages['delete']}
                    </Button>
                </div>
            )}
        >
            <div style={{ padding: '10px 25px' }}>
                {`${messages['deleteDriverScheduledTasks_deleteConfirmation']} "${tasks?.driverTaskName}" ${messages['deleteDriverScheduledTasks_for']} ${driver?.name || driverName || ''}?`}
            </div>
            <NotificationContainer />
        </Modal>

    )
}

export default DeleteDriverScheduledTask